import {Divider, Row, Tag} from 'antd';
import React from "react";
import StyledDrawer from "./CompanyDetailsDrawer.style";

const DescriptionItem = ({title, content}) => (
    <div className="site-description-item-profile-wrapper">
        <p className="site-description-item-profile-p-label">{title}:</p>&nbsp;{content}
    </div>
);

const columnsToDisplay = [
    {key: 'companyName', title: 'Company Name'},
    {key: 'representativeFullName', title: 'Representative'},
    {key: 'email', title: 'Email'},
    {key: 'telephone', title: 'Phone Number'},
    {key: 'companyPib', title: 'Company PIB'},
    {key: 'zipCode', title: 'Zip Code'},
    {key: 'street', title: 'Street'},
    {key: 'city', title: 'City'},
    {key: 'country', title: 'Country'}
];

const CompanyDetailsDrawer = ({darkMode, companyToShowDetailsFor, companyDetailsVisible, toggleCompanyDetails}) => {

    return companyToShowDetailsFor ? (
        <StyledDrawer
            width={280}
            darkMode={darkMode}
            className={darkMode && 'dark-mode'}
            placement="right"
            onClose={() => toggleCompanyDetails(false)}
            visible={companyDetailsVisible}
        >
            <p className="site-description-item-profile-p" style={{marginBottom: 24}}>
                Company Info
            </p>
            {
                columnsToDisplay.map(({key, title}) => (<Row key={key}>
                    <DescriptionItem title={title} content={companyToShowDetailsFor[key]}/>
                </Row>))
            }
            {
                companyToShowDetailsFor.softwareProducts && companyToShowDetailsFor.softwareProducts.length && (<>
                    <Divider/>
                    <p className="site-description-item-profile-p">Company Products</p>
                    {
                        companyToShowDetailsFor.softwareProducts.map(({companyHasSoftwareProductCode}) => <Tag
                            className='software-product-tag' key={companyHasSoftwareProductCode}>
                            {companyHasSoftwareProductCode}
                        </Tag>)
                    }
                </>)
            }

        </StyledDrawer>
    ) : null;
};

export default CompanyDetailsDrawer;